import rec1 from "../../Assets/rec1.png";
import rec2 from "../../Assets/rec2.png";
import rec3 from "../../Assets/rec3.png";
import rec4 from "../../Assets/rec4.png";
import rec5 from "../../Assets/rec5.png";
import rec6 from "../../Assets/rec6.png";
import rec7 from "../../Assets/rec7.png";
import rec8 from "../../Assets/rec8.png";
import whychoose1 from "../../Assets/whychoose1.png"
import whychoose2 from "../../Assets/whychoose2.png"
import whychoose3 from "../../Assets/whychoose3.png"
import whychoose4 from "../../Assets/whychoose4.png"
import user1 from "../../Assets/user1.png"
import user2 from "../../Assets/user2.png"
import harshita from "../../Assets/harshita.png"
import adithyaLogo from "../../Assets/hs1.png"
import kamalaLogo from "../../Assets/hs2.png"
import novacareLogo from "../../Assets/hs3.png"
import expert from "../../Assets/expert-care.png"

export const serviceShowcaseData = [
  {
    imgSrc: expert,
    title: `Expert Care \n Close To Home`,
    buttonText: "Book Now",
    // onButtonClick: () => console.log("Button Clicked"),
  }
]

export const recoveryItems = [
  {
    title: "Post Surgery Care",
    desc:
      "Monitor vitals, wound care, mobility assistance, respiratory care, fluid management, & so on",
    img: rec1,
  },
  {
    title: "Elderly Care",
    desc:
      "Care planning, mobility assistance, nutritional support, cognitive stimulation, emotional support, & so on",
    img: rec2,
  },
  {
    title: "Palliative Care",
    desc:
      "Care planning, symptom management, medication management, advance care planning, education & support, & so on",
    img: rec3,
  },
  {
    title: "Hospice Care",
    desc: `Care planning, symptom management, end-of-life care, emotional support, advance care planning, & so on`,
    img: rec7
  },
  {
    title: "Respite Care",
    desc:
      "Care planning, assistance with activities of daily living, monitoring vitals, respite for caregivers, safety & comfort",
    img: rec4,
  },
  {
    title: "Companionship",
    desc:
      "Emotional support, supporting independence, cultural & spiritual support, activities to alleviate boredom, & so on",
    img: rec5,
  },
  {
    title: "Medication Management",
    desc:
      "Medication administration, reconciliation, counseling, monitoring for adverse effects, refills, renewals, and safety",
    img: rec6,
  },

  {
    title: "Safety Concerns ",
    desc: "Assessment of home environment, fall prevention, medication safety, prevention of infections, emergency preparedness, monitoring vitals, & so on ",
    img: rec8

  }
];
export const recoverycontainerh2 = `Your Partner In Recovery`;



export const whyHeading = `Why Choose Home Nurse Services By Wihan`;

export const whyCards = {
  c1: { img: whychoose1, title: "Verified Background" },
  c2: { img: whychoose2, title: "Seamless Substitution" },
  c3: { img: whychoose3, title: "Quick Scheduling" },
  c4: { img: whychoose4, title: "Licensed Nursing Professionals" },
};


export const testimonialData = [
  {
    title: `Hear From The Healed`,

    desc: "I can not thank Wihan home nurse team enough for the support they provided to our family during a challenging time. Their professionalism and dedication made all the difference in my father's recovery. Thank you for bringing quality care right to our doorstep",
    userimg: user1,
    username: "Indira"

  },
  {
    title: `Hear From The Healed`,
    desc: "Recovering from knee replacement surgery was daunting until I startedphysiotherapy sessions at home through your team. The therapist was experienced, friendly, and walked in with all the right equipment. They have patiently guided me through each session. In just a few weeks, I felt stronger and more confident.",
    userimg: user2,
    username: "Mrs Veena Thomas",
  },
  {
    title: `Hear From The Healed`,
    desc: "After my back injury, I was worried about long hospital visits. Thanks to your home physiotherapy service, recovery became convenient and stress-free. The therapist understood my pain points and customized every session. Now I can move freely without discomfort.",
    userimg: harshita,
    username: "Indira"

  },
]

export const truncateLetters = (str, num) => {
  return str.length > num ? str.slice(0, num) + "..." : str;
};

export const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,        // enable autoplay
  autoplaySpeed: 3000,   // 3 seconds
  pauseOnHover: true,    // stop sliding when hovered
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 2 }
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 1 }
    }
  ]
};

export const settings2 = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 3 }
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 3 }
    },
    {
      breakpoint: 425,
      settings: { slidesToShow: 2 }
    },
    {
      breakpoint: 320,
      settings: { slidesToShow: 1 }
    }
  ]
};

export const hospitals = [
  { name: 'SHRI ADITHYA Hospitals', logo: adithyaLogo },
  { name: 'SRESHTA SRI KAMALA HOSPITALS', logo: kamalaLogo },
  { name: 'NOVACARE HOSPITALS', logo: novacareLogo },
];

export const experienceData = {
  heading: "Experience The Difference",
  paragraph: `Our approach goes beyond traditional medical care to encompass
  emotional support, companionship, and empowerment. With
  innovative technology and compassionate nursing, we're
  transforming the home into a place of healing, comfort,
  and independence.`,
};

export const expertCareData = {
  heading: "Nursing Services, Redefined For Modern Age",
  paragraph: `Our skilled and dedicated nurses would provide you personalized assistance with daily activities, and emotional support, all in the comfort of your own home. With a focus on your well-being and convenience, we strive to make your healing journey as smooth and comfortable as possible. We ensure that you receive the highest quality care in the most familiar environment.`,
};

export const weDoItDifferentlyData = {
  heading: "We Do It Differently",
  paragraph: `Provide a seamless care continuum through our homecare services,
  backed by our specialized care centers.`,
  list: [
    "Protocol-driven care management",
    "Care delivered through a multi-disciplinary collaborative approach",
    "All these at convenient pricing",
  ],
};

export const healedtitle = `Hear From The Healed`;
export const leadingtitle = `Trusted By Leading Hospitals`;
export const whychoosetitle = `Why Choose Home Nurse Services By Wihan`;